<div>
  <form [formGroup]="titleForm">
    <div formArrayName="titles">
      <nz-table
        #sortTable
        [nzData]="titles.controls.length > 0 ? titles.controls : []"
        [nzLoading]="loading"
        [nzSize]="'middle'"
        [nzShowPagination]="false"
        [nzNoResult]="customNoResult"
        (nzQueryParams)="onQueryParamsChange($event)">
        <thead>
          <tr>
            <th
              scope="col"
              [nzSortFn]="listOfColumn[0].compare"
              [title]="listOfColumn[0].title"
              [nzColumnKey]="listOfColumn[0].key">
              {{ listOfColumn[0].title }}
            </th>
            <th scope="col" nzWidth="40%"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let title of titles.controls; let i = index"
            [formGroupName]="i"
            (keydown.enter)="onEnterKey(i, $event)">
            <td>
              <input
                nz-input
                formControlName="title"
                [id]="'title' + i"
                placeholder="Enter the title"
                [disabled]="disableControl(i)"
                (key.enter)="SubmitTitle(i)" />
              <div
                class="ant-form-item-explain-error mt-3"
                *ngIf="title.get('title')?.hasError('maxlength')">
                Title cannot exceed 100 characters.
              </div>
            </td>

            <!-- Actions -->
            <td *ngIf="editingIndex === i">
              <div class="action-btn-wrapper">
                <button
                  type="button"
                  nz-button
                  [nzType]="'default'"
                  class="btn"
                  (click)="onCancel(i)"
                  (key.enter)="onCancel(i)">
                  Cancel
                </button>
                <button
                  type="button"
                  nz-button
                  [nzType]="'primary'"
                  class="btn"
                  [nzLoading]="isUpdating[i] && loading"
                  [disabled]="title.get('title')?.invalid || loading"
                  (click)="SubmitTitle(i)"
                  (key.enter)="SubmitTitle(i)">
                  Save
                </button>
              </div>
            </td>
            <td *ngIf="editingIndex !== i">
              <div class="action-btn-wrapper">
                <button
                  nz-button
                  nzType="default"
                  class="action-btn"
                  (click)="editTitle(i)">
                  <svg-icon
                    [title]="'Edit Title'"
                    src="/assets/icon/icon-edit.svg"
                    class="icon s-20"
                    aria-label="Edit"></svg-icon>
                </button>
                <button
                  nz-button
                  nzType="default"
                  class="action-btn"
                  (click)="showDeleteModal(i)">
                  <svg-icon
                    [title]="'Delete Title'"
                    src="/assets/icon/icon-trash.svg"
                    class="icon s-20"
                    aria-label="Trash"></svg-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </form>
</div>

<app-confirm-dialog
  [isVisible]="isVisible"
  [title]="'Delete Title'"
  [message]="
    'Are you sure you want to delete this Title? This action cannot be undone.'
  "
  [iconSrc]="'/assets/icon/icon-trash-red.svg'"
  [iconColor]="'red'"
  [cancelText]="'Cancel'"
  [loading]="isDeleting"
  [confirmText]="'Delete'"
  (confirmed)="handleOkMiddle()"
  (cancelled)="handleCancelMiddle()"
  (closed)="handleCancelMiddle()">
</app-confirm-dialog>

<ng-template #customNoResult>
  <div class="no-data-wrapper" *ngIf="titles.controls.length <= 0">
    <div class="no-data-text">No Titles Available</div>
  </div>
</ng-template>
